import React from 'react';

// Don't touch this import
import { fetchQueryResultsFromTermAndValue } from '../api';

//Searchable hyperlink we use in Feature
const Searchable = ({ searchTerm, searchValue, setIsLoading, setSearchResults }) => {
    return (
        <span className="content">
            <a href={`${searchValue}`}
                onClick={async (event) => {
                    event.preventDefault();
                    setIsLoading(true);
                    try {
                        const result = await fetchQueryResultsFromTermAndValue(searchTerm, searchValue);
                        setSearchResults(result);
                    } catch (error) {
                        console.error(error)
                    } finally {
                        setIsLoading(false);
                    }
                }}
            >{searchValue}</a>
        </span>
    )
}

//Feature div that gives the details about the artwork
const Feature = (props) => {
    const { featuredResult, setIsLoading, setSearchResults } = props
    if (featuredResult) {
        const {
            title,
            dated,
            images,
            primaryimageurl,
            description,
            culture,
            style,
            technique,
            medium,
            dimensions,
            people,
            department,
            division,
            contact,
            creditline
        } = featuredResult;

        return (
            <main id="feature">
                <div className="object-feature">
                    <header>
                        <h3>{title}</h3>
                        <h4>{dated}</h4>
                    </header>
                    <section className="facts">
                        {description ? (
                            <>
                                <span className='title'>Description</span>
                                <span className='content'>{description}</span>
                            </>
                        ) : ''}

                        {culture ? (
                            <>
                                <span className='title'>Culture</span>
                                <Searchable
                                    searchTerm='culture'
                                    searchValue={culture}
                                    setIsLoading={setIsLoading}
                                    setSearchResults={setSearchResults}
                                />
                            </>
                        ) : ''}

                        {style ? (
                            <>
                                <span className='title'>Style</span>
                                <span className='content'>{style}</span>
                            </>
                        ) : ''}

                        {technique ? (
                            <>
                                <span className='title'>Technique</span>
                                <Searchable
                                    searchTerm='technique'
                                    searchValue={technique}
                                    setIsLoading={setIsLoading}
                                    setSearchResults={setSearchResults}
                                />
                            </>
                        ) : ''}

                        {medium ? (
                            <>
                                <span className='title'>Medium</span>
                                <Searchable
                                    searchTerm='medium'
                                    searchValue={medium.toLowerCase()}
                                    setIsLoading={setIsLoading}
                                    setSearchResults={setSearchResults}
                                />
                            </>
                        ) : ''}

                        {dimensions ? (
                            <>
                                <span className='title'>Dimensions</span>
                                <span className='content'>{dimensions}</span>
                            </>
                        ) : ''}

                        {people ? (
                            <>
                                <span className='title'>People</span>
                                {people.map((person) => {
                                    return <Searchable key={person.personid}
                                        searchTerm='person'
                                        searchValue={person.displayname}
                                        setIsLoading={setIsLoading}
                                        setSearchResults={setSearchResults}
                                    />
                                })}
                            </>
                        ) : ''}

                        {department ? (
                            <>
                                <span className='title'>Department</span>
                                <span className='content'>{department}</span>
                            </>
                        ) : ''}

                        {division ? (
                            <>
                                <span className='title'>Division</span>
                                <span className='content'>{division}</span>
                            </>
                        ) : ''}

                        {contact ? (
                            <>
                                <span className='title'>Contact</span>
                                <span className='content'><a target="" href={`mailto:${contact}`}>{contact}</a></span>
                            </>
                        ) : ''}

                        {creditline ? (
                            <>
                                <span className='title'>Credit</span>
                                <span className='content'>{creditline}</span>
                            </>
                        ) : ''}
                    </section>

                    {
                        <section className='photos'>
                            {primaryimageurl ? images ? images.map((image) => {
                                return <img
                                    key={image.idsid}
                                    src={image.baseimageurl}
                                    alt={image.description}
                                />
                            }) : '' : <span>NO IMAGE</span>}
                        </section>

                    }
                </div>
            </main>
        )
    } else {
        return <main id='feature'></main>;
    }
}

export default Feature;